import React from "react";


export const Anchor = ({ id, top }) => {
  return (
    <div style={{ position: "relative", top }} id={id}/>
  )
};
